(function(){

let checkHasJquery = setInterval(function(){
    if(typeof window.jQuery === 'function') {
        clearInterval(checkHasJquery);
        console.log('jq loaded.');

        const updatePriceFn = () => {
            let optionValueId = $('variant-selects').find('input[type="radio"]:checked').data('optionValueId');
            let optionDiv     = [];
            if(optionValueId) {
                optionDiv = $('#option-value-'+optionValueId);
            } else {
                optionDiv = $('.all-product-option-values:first');
            }
            if(optionDiv.length) {
                let displayPriceBtn = document.getElementById('display-price-at-btn');
                if(displayPriceBtn) {
                    let isSellPlan = $('.product__block__subscription').find('input[name="selling_plan"]:checked').val();
                    let currentDisplayPrice = '';
                    if(isSellPlan) {
                        displayPriceBtn.innerText = optionDiv.data('atprice');
                        currentDisplayPrice = optionDiv.data('atprice');
                    } else {
                        displayPriceBtn.innerText = optionDiv.data('price');
                        currentDisplayPrice = optionDiv.data('price');
                    }
                    displayPriceBtn.classList.remove('hidden');
                    const itemPrices = document.querySelectorAll('.f-price-item--regular');
                    itemPrices.forEach(item => {
                        if(item.children.length === 0) {
                            item.innerText = currentDisplayPrice;
                        }
                    });
                }
                document.querySelectorAll('.one-time-purchase-price').forEach(item => {
                    item.innerText = optionDiv.data('price');
                });
                let deliveryEveryMonth = document.querySelector('.delivery-every-month-price');
                if(deliveryEveryMonth) { deliveryEveryMonth.innerText = optionDiv.data('atprice'); }
            }
        };

        const updateSetSubscription = () => {
            console.log('subscription.');
            let stickyForms = $('.sticky-atc-bar__form');
            if(stickyForms.length) {
                stickyForms.find('input[name="selling_plan"]').remove();
                let sellingPlan = $('.product__block__subscription input[name="selling_plan"]:checked').val();
                if(sellingPlan) {
                    stickyForms.append('<input type="hidden" name="selling_plan" value="'+sellingPlan+'" />');
                }
            }
        };

        document.addEventListener('quick-view:loaded', function(e) {
            console.log('quick-view:loaded');
            updatePriceFn();
        });

        //variant-selects input[type="radio"]
        $(document).on('change', '.product__block__subscription input[name="selling_plan"]', function(e) {
            console.log('variant-selects');
            updatePriceFn();
            updateSetSubscription();
        });

        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
            console.log('PUB_SUB_EVENTS.variantChange');
            updatePriceFn();
        });
        //$('variant-selects').find('input[type="radio"]:checked').trigger('change');
        updatePriceFn();
        updateSetSubscription();
    }
}, 1000);

})();